import "./App.css";
import Routers from "../../router";
import { ThemeProvider } from "styled-components";
import { darkTheme, defaultTheme } from "style/preset";
import { Toaster } from "react-hot-toast";
import useInitData from "hooks/useInitData";

const App = () => {
  useInitData()
  
  return (
    <ThemeProvider theme={() => {
      return defaultTheme
    }}>
      <Routers></Routers>
      <Toaster  toastOptions={{
        duration: 1000
      }}/>
    </ThemeProvider>
  );
};

export default App;
